import React from 'react';
import indicator from './loading.svg';
import styled from '@emotion/styled';

const StyledContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100vw;
`;
const StyledLoadingImage = styled.img`
    height: 80px;
`;

function Loading() {
    return (
        <StyledContainer>
            <StyledLoadingImage
                src={indicator}
                alt="loading"
            />
        </StyledContainer>
    );
}

export default Loading;
